import { apiService } from './api';
import { City } from '../types/user';
import { AxiosResponse } from 'axios';

export const cityService = {
    getAllCities(): Promise<AxiosResponse<City[]>> {
        return apiService.get<City[]>('/City');
    },
};
